import styles from './SearchResultPage.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import SearchResultSummary from 'SearchResultSummary/SearchResultSummary';
import SearchResultList from 'SearchResultList/SearchResultList';
import TieredSearchResultList from 'TieredSearchResultList/TieredSearchResultList';
import ZeroResults from 'ZeroResults/ZeroResults';
import ResultsError from 'ResultsError/ResultsError';
import AdPanel from 'AdPanel/AdPanel';
import Leaderboard from 'Leaderboard/Leaderboard';
import Loader from 'Loader/Loader';
import Pagination from 'Pagination/Pagination';
import SearchResultHeader from 'SearchResultHeader/SearchResultHeader';
import DidYouMean from 'DidYouMean/DidYouMean';
import Lmis from 'Lmis/Lmis';
import Suburbs from 'Suburbs/Suburbs';
import SavePanel from 'SavePanel/SavePanel';

const getRootClasses = hideResults => (
  classnames({
    [styles.root]: true,
    [styles.root_areResultsHidden]: hideResults
  })
);

const getLoaderClasses = hideLoader => (
  classnames({
    [styles.loader]: true,
    [styles.loader_isHidden]: hideLoader
  })
);

function mapStateToProps({ results, search, saveSearch, user }) {
  return {
    searchResultsViewModel: results.results,
    saveable: saveSearch.saveable,
    query: search.query,
    resultsHidden: results.hidden,
    authenticated: user.authenticated
  };
}

@connect(mapStateToProps)
class SearchResultPage extends Component {

  static propTypes = {
    authenticated: PropTypes.bool.isRequired,
    searchResultsViewModel: PropTypes.object,
    saveable: PropTypes.bool.isRequired,
    query: PropTypes.object,
    resultsHidden: PropTypes.bool.isRequired
  };

  renderLoader(isLoading) {
    return (
      <div className={getLoaderClasses(!isLoading)} key="loading">
        <Loader data-automation="searchResultsLoader" />
      </div>
    );
  }

  renderResults(viewModel) {
    const { isZeroResults, jobs, header, tiers, hasHeaderBeforeJobs, suggestions, isError } = viewModel;
    const { saveable, authenticated } = this.props;
    const hasResults = !isError && !isZeroResults;
    const resultsClassName = classnames({
      [styles.separator]: hasHeaderBeforeJobs
    });

    return (
      <div key="content" data-automation="searchResults">
        { isError && <ResultsError /> }
        { isZeroResults && <ZeroResults /> }
        {
          hasResults && (
            <div className={resultsClassName}>
              { header && <SearchResultHeader message={header} /> }
              { suggestions && <DidYouMean locations={suggestions} /> }
              { tiers && <TieredSearchResultList header={header} tiers={tiers} /> }
              { jobs && <SearchResultList jobs={jobs} /> }
              { saveable && <SavePanel {...{ authenticated }} /> }
              <div className={styles.lmis}><Lmis /></div>
              <div className={styles.pagination}>
                <Pagination />
              </div>
            </div>
          )
        }
      </div>
    );
  }

  render() {
    const { resultsHidden, searchResultsViewModel } = this.props;

    if (resultsHidden) {
      return (
        <section className={getRootClasses(resultsHidden)}>
          <span data-automation="hiddenSearchResults" />
        </section>
      );
    }

    const { isLoading, isError, summary, isZeroResults } = searchResultsViewModel;

    return (
      <section className={getRootClasses(isLoading)}>
        <div className={styles.container}>
          <SearchResultSummary isLoading={isLoading} {...summary} />
          <div className={styles.resultsColumns}>
            <div className={styles.ads}>
              { !isError && <AdPanel /> }
            </div>
            <div className={classnames(styles.content, styles.loaderContainer)}>
              { this.renderLoader(isLoading) }
              {
                !isError && this.renderResults(searchResultsViewModel)
              }
              {
                (!isLoading && !isError && !isZeroResults) && (
                  <div className={styles.leaderboard}>
                    <Leaderboard />
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <Suburbs />
      </section>
    );
  }

}

export default SearchResultPage;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/SearchResultPage.js
 **/